import { Lock, Eye } from 'lucide-react';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Button } from '@/shared/ui/elements/button/Button';

function ResetPasswordModal() {
  const [showNewPassword, setShowNewPassword] = useState(false);
  const [showConfirmPassword, setShowConfirmPassword] = useState(false);
  const [t] = useTranslation('login');

  return (
    <div>
      {/* className="p-6 bg-white rounded-lg shadow-lg w-full max-w-md mx-auto" */}
      {/* Header */}
      <div
        data-slot="dialog-header"
        className="flex flex-col gap-2 text-center sm:text-left"
      >
        {/* Icon */}
        <div className="flex justify-center mb-4">
          <div className="w-16 h-16 bg-slate-900 rounded-full flex items-center justify-center">
            <Lock className="w-8 h-8 text-white" />
          </div>
        </div>

        {/* Title */}
        <h2
          data-slot="dialog-title"
          className="font-semibold text-center text-2xl text-slate-900"
        >
          {t('resetYourPassword')}
        </h2>

        {/* Description */}
        <p
          data-slot="dialog-description"
          className="text-sm text-center text-slate-500"
        >
          {t('createStrongPassword')}
        </p>
      </div>

      {/* Form */}
      <form className="space-y-5 py-4">
        {/* New Password */}
        <div className="space-y-2">
          <label
            htmlFor="new-password"
            data-slot="label"
            className="flex items-center gap-2 text-sm leading-none font-medium select-none 
                       group-data-[disabled=true]:pointer-events-none group-data-[disabled=true]:opacity-50
                       peer-disabled:cursor-not-allowed peer-disabled:opacity-50 text-slate-700"
          >
            {t('newPassword')}
          </label>
          <div className="relative">
            <input
              type={showNewPassword ? 'text' : 'password'}
              data-slot="input"
              id="new-password"
              placeholder={t('enterNewPassword')}
              required
              className="file:text-foreground placeholder:text-muted-foreground 
                         selection:bg-primary selection:text-primary-foreground
                         dark:bg-input/30 flex w-full min-w-0 border px-3 py-1 text-base 
                         bg-input-background transition-[color,box-shadow] outline-none
                         file:inline-flex file:h-7 file:border-0 file:bg-transparent
                         file:text-sm file:font-medium disabled:pointer-events-none 
                         disabled:cursor-not-allowed disabled:opacity-50 md:text-sm
                         focus-visible:border-ring focus-visible:ring-ring/50 focus-visible:ring-[3px]
                         aria-invalid:ring-destructive/20 dark:aria-invalid:ring-destructive/40
                         aria-invalid:border-destructive h-12 border-slate-300 rounded-lg pr-10"
            />
            <button
              type="button"
              className="absolute right-3 top-1/2 -translate-y-1/2 text-slate-400 hover:text-slate-600"
              onClick={() => setShowNewPassword(!showNewPassword)}
            >
              <Eye className="w-5 h-5" />
            </button>
          </div>
        </div>

        {/* Confirm Password */}
        <div className="space-y-2">
          <label
            htmlFor="confirm-password"
            data-slot="label"
            className="flex items-center gap-2 text-sm leading-none font-medium select-none 
                       group-data-[disabled=true]:pointer-events-none group-data-[disabled=true]:opacity-50
                       peer-disabled:cursor-not-allowed peer-disabled:opacity-50 text-slate-700"
          >
            {t('confirmPassword')}
          </label>
          <div className="relative">
            <input
              type={showConfirmPassword ? 'text' : 'password'}
              data-slot="input"
              id="confirm-password"
              placeholder={t('reEnterNewPassword')}
              required
              className="file:text-foreground placeholder:text-muted-foreground 
                         selection:bg-primary selection:text-primary-foreground
                         dark:bg-input/30 flex w-full min-w-0 border px-3 py-1 text-base 
                         bg-input-background transition-[color,box-shadow] outline-none
                         file:inline-flex file:h-7 file:border-0 file:bg-transparent
                         file:text-sm file:font-medium disabled:pointer-events-none 
                         disabled:cursor-not-allowed disabled:opacity-50 md:text-sm
                         focus-visible:border-ring focus-visible:ring-ring/50 focus-visible:ring-[3px]
                         aria-invalid:ring-destructive/20 dark:aria-invalid:ring-destructive/40
                         aria-invalid:border-destructive h-12 border-slate-300 rounded-lg pr-10"
            />
            <button
              type="button"
              className="absolute right-3 top-1/2 -translate-y-1/2 text-slate-400 hover:text-slate-600"
              onClick={() => setShowConfirmPassword(!showConfirmPassword)}
            >
              <Eye className="w-5 h-5" />
            </button>
          </div>
        </div>

        {/* Buttons */}
        <div className="flex gap-3 pt-2">
          <Button
            type="button"
            data-slot="button"
            variant="outlineGray"
            size="flex"
            className="has-[&>svg]:px-3"
          >
            {t('cancel')}
          </Button>

          <Button
            type="submit"
            data-slot="button"
            variant="primaryBlue" // or "verify" if that’s what you prefer
            size="flex"
            disabled
            className="has-[&>svg]:px-3"
          >
            {t('resetPassword')}
          </Button>
        </div>
      </form>
    </div>
  );
}

export default ResetPasswordModal;
